import { IconError, Card } from 'cdk-radial';
import styled from 'styled-components';
import { Dialog } from 'components/Dialog';

export const IconErrorStyle = styled(IconError)`
  fill: red;
  padding-right: 7px;
  vertical-align: bottom;
`;

export const StyledFailureDialog = styled(Dialog)`
  width: 36%;
`;

export const StyledDialogContainer = styled.div`
  width: '700px';
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const StyledDialogCard = styled(Card)`
  display: flex;
  padding-bottom: 1%;
`;
